module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/mags/ortho-field-config-translation.json
// module id = 1222
// module chunks = 0